import { Text, Tooltip, TooltipContent, TooltipTrigger } from '@/ui-kit'
import { CircleAlert } from 'lucide-react'
import { WorkerType } from '../api/models'

export function DeviceOutdatedVersionTooltip({ type }: { type: WorkerType }): React.JSX.Element {
  return (
    <Tooltip delayDuration={0}>
      <TooltipTrigger className="flex items-center gap-2 text-[var(--colorOrange)]">
        <span className="text-inherit">{type.toLowerCase() === 'extension' ? 'Browser' : 'Mobile'}</span>
        <CircleAlert height={20} width={20} className="h-4 w-4" />
      </TooltipTrigger>
      <TooltipContent sideOffset={8} className="!text-base">
        <Text
          className="block max-w-[400px] whitespace-pre-line text-wrap text-center text-[var(--colorWhiteToBlack)] max-mobile:max-w-none"
          type="body1-regular"
        >
          Your app version is outdated
        </Text>
      </TooltipContent>
    </Tooltip>
  )
}
